import { render, staticRenderFns } from "./ModalStepFooter.vue?vue&type=template&id=5b08bab9&scoped=true&"
import script from "./ModalStepFooter.vue?vue&type=script&lang=js&"
export * from "./ModalStepFooter.vue?vue&type=script&lang=js&"
import style0 from "./ModalStepFooter.vue?vue&type=style&index=0&id=5b08bab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08bab9",
  null
  
)

export default component.exports